<template>
    <div class="form-container">
        <div class="section-wrapper">
            <InputField
                :name="name"
                ref="name"
                :validationRules="validationRules"
                :customErrorMessage="errorMessage"
                :label="label"
            />
        </div>
    </div>
</template>

<script>
import { useStore } from 'vuex'

export default {
    // static settings to initialize step (not reactive inside this file!)
    stepDefinition() {
        return {
            name: 'financesBankAccountNumber',
            route: {
                relativeUrl: process.env.TERRITORY === 'pol' ? `numer-konta` : `bank-account-number`,
                name: 'apply.financesBankAccountNumber',
                meta: {
                    title: 'form.sections.finances.bankAccount.heading',
                    tooltip: 'form.sections.finances.bankAccount.tooltip',
                    tooltipType: 'small',
                },
            },
            fields: {
                bankAccountNo: {
                    value: null,
                    mappedKey: 'bank_account_no',
                    mask: '## #### #### #### #### #### ####',
                    validationRules: {
                        required: true,
                        min: 32,
                        max: 32,
                    },
                    hideOnSummary: true,
                    ignorePrepopulation: true,
                },
            },
        }
    },

    setup() {
        const store = useStore()

        return {
            store,
        }
    },
    mounted() {
        this.autoFocus(this.$refs.name)
    },
    data() {
        return {
            label: `${this.$t('form.fields.bankAccountNo.label')}`,
            name: 'bankAccountNo',
            errorMessage: `${this.$t('form.fields.bankAccountNo.errorMessage')}`,
            validationRules: this.store.getters.fieldValidationRules('bankAccountNo'),
        }
    },
    created() {
        this.emitter.emit('stepLoaded')
    },
}
</script>

<style lang="scss" scoped>
.section-wrapper {
    margin-left: auto;
    margin-right: auto;
}
</style>
